
import { defineComponent } from "vue";

// Component definition
export default defineComponent({
  name: "WheelSwipeNotice",
  props: {
    isShow: {
      type: Boolean,
      required: true
    },
    duration: {
      type: Number,
      default: 4
    }
  },
  setup() {
    return {};
  }
});
